// extracted by mini-css-extract-plugin
export default {"root":"ReferenceItem--root--1n-4x","link":"ReferenceItem--link--2B3aw"};